import { render, staticRenderFns } from "./JRC.vue?vue&type=template&id=fd21946e"
import script from "./JRC.vue?vue&type=script&lang=js"
export * from "./JRC.vue?vue&type=script&lang=js"
import style0 from "./JRC.vue?vue&type=style&index=0&id=fd21946e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports